// extracted by mini-css-extract-plugin
export default {"filterBar":"TaskFilters_filterBar__FSJak","filterSelect":"TaskFilters_filterSelect__Hapho"};